import React from 'react'
import './ExampleCarouselImage.css'

const ExampleCarouselImage = ({img}) => {
  return (
    <img src={img} alt='carousel-img'/>
  )
}

export default ExampleCarouselImage